const MLB_CSV_HEADER_DK = [
  'P',
  'P',
  'C',
  '1B',
  '2B',
  '3B',
  'SS',
  'OF',
  'OF',
  'OF',
];

const NFL_CSV_HEADER_DK = [
  'QB',
  'RB',
  'RB',
  'WR',
  'WR',
  'WR',
  'TE',
  'FLEX',
  'DST',
];

const MLB_CSV_HEADER_FD = [
  'P',
  'C/1B',
  '2B',
  '3B',
  'SS',
  'OF',
  'OF',
  'OF',
  'UTIL',
];

const NFL_CSV_HEADER_FD = [
  'QB',
  'RB',
  'RB',
  'WR',
  'WR',
  'WR',
  'TE',
  'FLEX',
  'DEF',
];

export {
  MLB_CSV_HEADER_DK,
  MLB_CSV_HEADER_FD,
  NFL_CSV_HEADER_FD,
  NFL_CSV_HEADER_DK,
};



// WEBPACK FOOTER //
// ./src/csv.js